'use client'

import { MOBILE_MENU_TEST_IDS } from '@common/common-test-ids.const'
import { AppVariant } from '@common/enums'

import { BaseMobileMenu } from '../../BaseMobileMenu'
import type { MobileMenuShellProps } from '../../mobileMenuShell.types'

export function ConferenceMobileMenu(props: MobileMenuShellProps) {
  return (
    <div data-testid={MOBILE_MENU_TEST_IDS.conferenceMenu} style={{ display: 'contents' }}>
      <BaseMobileMenu {...props} appVariant={AppVariant.CONFERENCE} />
    </div>
  )
}
